'use strict';

angular.module('DoohApps').constant('Constants', (
    function ConstantsConstant() {
        let userStatus = {
            active: 'Active',
            approved: 'Approved',
            rejected: 'Rejected'
        }

        return {
            defaultLanguageISOCode: 'en',
            userStatus
        }
    }
)());
